import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';
import { useRoute, RouterLink } from 'vue-router';
import { AxiosResponse } from 'axios';

import { useUiStore } from '@/stores';
import ConnectFlowService from '@/services/api/ConnectFlowService';
import { toastServiceError } from '@/services/core/notification';
import { ConnectFlowModel, Permission } from '@/types';
import { applyPhoneMask } from '@/utils/number';

import { PhoneIcon } from '@heroicons/vue/solid';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConnectFlowDetailPage',
  setup(__props, { expose: __expose }) {
  __expose();

const route = useRoute();
const uiStore = useUiStore();

const connectFlow = ref<ConnectFlowModel | undefined>(undefined);

const setLoading = (loading: boolean) => uiStore.setIsLoading(loading);

const fetchConnectFlow = async (id: number) => {
    await setLoading(true);
    try {
        const response: AxiosResponse<ConnectFlowModel> =
            await ConnectFlowService.get<ConnectFlowModel>(id);
        connectFlow.value = response.data;
    } catch (error) {
        toastServiceError(error);
    } finally {
        await setLoading(false);
    }
};

onMounted(() => {
    const id = Number(route.params.id);
    fetchConnectFlow(id);
});

const __returned__ = { route, uiStore, connectFlow, setLoading, fetchConnectFlow, get RouterLink() { return RouterLink }, get Permission() { return Permission }, get applyPhoneMask() { return applyPhoneMask }, get PhoneIcon() { return PhoneIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})